import { ExternalLink } from 'lucide-react'
import type { ReactNode } from 'react'

/**
 * Link to the original page of a quoted source (owner rule: always link the source). Opens a new tab; the URL comes from
 * the builders in @iqrapath/shared (links.ts), never from free text.
 */
export function SourceLink({ href, children, className = '' }: { href: string; children: ReactNode; className?: string }) {
  return (
    <a className={`src-link ${className}`} href={href} target="_blank" rel="noopener noreferrer">
      <span>{children}</span>
      <ExternalLink size={12} aria-hidden="true" />
      <span className="sr"> (buka sumber di tab baru)</span>
    </a>
  )
}
